/* eslint-disable */
import React from 'react';

// MUI
import Typography from '@mui/material/Typography';

// Types
import { ITableHeadingProps } from '@/@types/ui/Table';

const TableHeading = (props: ITableHeadingProps) => {
  const { children } = props;
  const isLongHeading = typeof children === 'string' && children.length > 20;
  return (
    <Typography
      align="left"
      variant="h5"
      component="h3"
      whiteSpace={'pre-line'}
      sx={{
        ml: "4px",
        mr: "8px",
        fontSize: {
          xs: '1.15rem',
          sm: '1.25rem',
          md: '1.3rem',
          lg: isLongHeading ? '1.3rem' : '1.5rem',
          xl: isLongHeading ? '1.4rem' : '1.5rem'
        },
      }}
    >
      {children}
    </Typography>
  );
};

export default TableHeading;
